import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import './PastStudentEntries.css';
import Paper from "@material-ui/core/Paper";
import { Alert } from "@material-ui/lab";
import moment from "moment";
import axios from "axios";

class PastStudentEntries extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: null,
      isLoaded: false,
      apiError: false
    };
  }

  componentDidMount() {
    axios.get(`/api/student/transaction-entries/${this.props.user.lcf_id}`)
      .then((result) => this.setState({
        history: result.data,
        isLoaded: true
      }))
      .catch(() => this.setState({apiError: true}));
  }

  total(amount) {
    let total = 0
    for (let i = 0; i < amount.length; i++) {
      const element = amount[i];
      total += Number(element.amt_to_savings)
    }return total.toFixed(2)
  }

  render() {
    const gunnarStyle = {
      minHeight: "150px",
      minWidth: "75px",
      textAlign:'center',
      fontSize: '86%',
      padding: '2px',
      border: '1px solid #d3d3d3'
    };

    const apiAlert = this.state.apiError === true && (
      <Alert className="error" style={{}} severity="error">
        A problem occurred when fetching past entries.
        Please try again later.
      </Alert>
    );

    if (!this.state.isLoaded) {
      return (
        <>
          {apiAlert}
          <div style={{ 'textAlign': 'center' }}>Loading...</div>
        </>
      );
    }

    const history = this.calcRunningBalance(this.state.history);

    return this.state.history.length === 0 ? (
      <Paper elevation={5} style={{margin:'5%', padding:'5%', textAlign:'center'}}>
        <h2>It looks like you don't have any past entries! Check back once you've made one.</h2>
      </Paper>
    ) : (
      <div style={{margin:'2%'}}>
        {apiAlert}
        <center><h1>Past Entries</h1></center><br/>
        <div style={{textAlign: 'right', margin: '4px'}}>
          {'Current Savings Balance: $' + history[0].running.toFixed(2)}
        </div>

        <Paper elevation={5}
          style={{height: "100%", overflow: "auto", border: "",}}>

          <Table
            style={{margin:'1%', borderCollapse: 'collapse', width: '98%'}}>
            <TableHead>
              <TableRow style={gunnarStyle}>
                <TableCell style={gunnarStyle}>Date</TableCell>
                <TableCell style={gunnarStyle}>Type</TableCell>
                <TableCell style={gunnarStyle}>Memo</TableCell>
                <TableCell style={gunnarStyle}>Total Earned</TableCell>
                <TableCell style={gunnarStyle}>Paycheck</TableCell>
                <TableCell style={gunnarStyle}>Saved</TableCell>
                <TableCell style={gunnarStyle}>Savings Balance</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.mapRows(history, gunnarStyle)}
            </TableBody>

          </Table>
        </Paper>

      </div>
    );
  }

  mapRows(history, style) {
    const currencyStyle = {
      minHeight: "150px",
      minWidth: "75px",
      textAlign:'right',
      fontSize: '86%',
      padding: '8px',
      border: '1px solid #d3d3d3',
    }
    
    const memoStyle = {
      minHeight: "150px",
      minWidth: "75px",
      textAlign:'left',
      fontSize: '75%',
      padding: '2px',
      border: '1px solid #d3d3d3'
    }

    return history.map((row, idx) => (
      <TableRow
        style={{backgroundColor: idx % 2 === 0 ? '#ddebf7' : 'none'}}
        key={row.lcf_id} >

        <TableCell style={style}>
          {moment.utc(row.moment ? row.moment : row.date_submitted)
            .format("M/D/YY")}
        </TableCell>
        <TableCell style={style}>
          {this.getTransactionType(row)}
        </TableCell>
        <TableCell style={memoStyle}>
          {this.generateMemo(row)}
        </TableCell>
        <TableCell style={currencyStyle}>{this.prependCurrency(row.gross_earned)}</TableCell>
        <TableCell style={currencyStyle}>{this.prependCurrency(row.paid_to_student)}</TableCell>
        <TableCell style={currencyStyle}>{this.prependCurrency(row.amount)}</TableCell>
        <TableCell style={currencyStyle}>{'$' + row.running.toFixed(2)}</TableCell>
      </TableRow>
    ));
  }

  generateMemo(row) {
    if (row.trx_type === 'manual') {
      return row.comment;
    }
    return (<>
      {row.gpa !== null ? (<>
        <div style={{display: 'flex', gap: '12px'}}>
          <div style={{flex: '%50'}}>
            {'- GPA: ' + row.gpa}<br/>
            {'- Clean Attend: ' + row.days_clean_attend}<br/>
            {'- Act. or Job: ' + (row.act_or_job ? 'Yes' : 'No')}<br/>
            {'- Service Hrs Met: ' + (row.service_hrs_met ? 'Yes' : 'No')}
          </div>
          <div style={{flex: '%50'}}>
            {'- Passing Classes: ' + (row.pass_class ? 'Yes' : 'No')}<br/>
            {'- Had Detention: ' + (row.had_detention ? 'Yes' : 'No')}<br/>
            {'- Substance Abuse: ' + (row.substance_abuse ? 'Yes' : 'No')}<br/>
            {'- Hub Attendance: ' + (row.hw_rm_attended ? 'Yes' : 'No')}
          </div>
        </div>
        <br/>
        {row.trx_type !== null ? (
          <div style={{display: 'flex', gap: '12px'}}>
            <div style={{flex: '%50'}}>
              {'- Total Earned: $' + row.gross_earned}<br/>
              {'- To Savings: $' + row.amount}<br/>
              {'- Donation: $' + row.pif_paid}
            </div>
            <div style={{flex: '%50'}}>
              {'- Balance Paid: $' + row.debt_paid}<br/>
              {'- Balance Remaining: $' + row.debt_remaining}<br/>
              {'- To Student: $' + row.paid_to_student}
            </div>
          </div>
        ) : (
          <>(pay check not yet processed)</>
        )}
      </>
      ) : (
        <div>No student entry for this pay period.</div>
      )}
      
    </>);
  }

  calcRunningBalance(history) {
    if (history.length === 0) {
      return history;
    }
    const toParse = history[history.length-1].amount
      ? history[history.length-1].amount : '0';
    history[history.length-1].running = parseFloat(toParse);
    for (let i = history.length-2; i >= 0; i--) {
      const subParse = history[i].amount
        ? history[i].amount : '0';
      history[i].running = history[i+1].running + parseFloat(subParse);
    }
    return history;
  }

  getTransactionType(row) {
    if (!row.trx_type) {
      return 'Pending Payday';
    }
    return row.trx_type === 'payday' ? 'Payday' : 'Adjustment';
  }

  // amount: string
  prependCurrency(amount) {
    if (!amount) {
      return "-";
    }
    return amount.startsWith('-') ? '-$' + amount.substring(1) : '$' + amount;
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  studentHistory: state.studentHistory.studentHistoryReducer,
  entry: state.entry.entryList
});

export default withRouter(connect(mapStateToProps)(PastStudentEntries));
